import { useEffect, useCallback, useState } from "react";
import { APP_EVENT_ID, XCHANGE_PLATFORM_NAME } from "../utils/consts";
import { USER_ROLES } from "../components/UserProvider";

// Meeting and Reception Removal URLs
const REMOVE_FROM_MEETING_URL = `${process.env.REACT_APP_API_ENDPOINT}/event/companyprofile/removeAttendeeFromMeetingList`;
const REMOVE_FROM_RECEPTION_URL = `${process.env.REACT_APP_API_ENDPOINT}/event/companyprofile/removeAttendeeFromReceptionList`;
// Removes a user's chat conversation from the Brunico chat service
const REMOVE_USERS_CHAT_CONVERSATION_URL = `${process.env.REACT_APP_XCHANGE_BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/Messaginghub/RemoveGuestReceptionistConversation`;

const useNotifyOnMeetingLeave = ({
  isLeavingReception = false,
  companyId,
  meetingId,
  userIsInvitee,
  userProfile,
  role: userRole,
}) => {
  const [removeFromMeetingUrl, setRemoveFromMeetingUrl] = useState();
  const [removeFromChatUrl, setRemoveFromChatUrl] = useState();

  // callback function that executes the sendBeacon request when
  // user leaves reception or a meeting.
  const removeAttendeeFromMeeting = useCallback(
    (url) => {
      if (!removeFromMeetingUrl || !removeFromChatUrl) {
        return;
      }
      // sendBeaconToServer(url);
      if (!navigator.sendBeacon) return true;

      navigator.sendBeacon(removeFromMeetingUrl);
      if (userRole && userRole === USER_ROLES.DELEGATE) {
        navigator.sendBeacon(removeFromChatUrl);
      }
    },
    [removeFromMeetingUrl, removeFromChatUrl, userRole]
  );

  // Set removal URLs for sendBeacon requests
  useEffect(() => {  
    if (userProfile && companyId && (isLeavingReception || (userIsInvitee && meetingId))){ 
      setRemoveFromMeetingUrl(
        isLeavingReception
          ? `${REMOVE_FROM_RECEPTION_URL}/${companyId}?attendeeid=${userProfile.AttendeeID}&eventid=${APP_EVENT_ID}`
          : `${REMOVE_FROM_MEETING_URL}/${meetingId}?attendeeid=${userProfile.AttendeeID}`
      );
      setRemoveFromChatUrl(
        `${REMOVE_USERS_CHAT_CONVERSATION_URL}?AttendeeID=${userProfile.AttendeeID}&CompanyID=${companyId}`
      );
  
    }
  }, [isLeavingReception, userIsInvitee, userProfile, companyId, meetingId]);

  // cleanup when user leaves a meeting/reception
  //
  // the reason we use a separate useEffect hook here is that we ONLY want
  // to run this whenever the user has either closed their tab/browser window
  // OR the removal URLs (for meeting and chat) have changed (or been set).
  useEffect(() => {
    if ((userIsInvitee || isLeavingReception) && removeFromMeetingUrl && removeFromChatUrl) {
      window.addEventListener("beforeunload", removeAttendeeFromMeeting);
    }
    return () => {
      // Unmounting... only remove user and do clean-up if user is a participant
      // of the meeting that's being left (ie: not being redirected to reception
      // from a meeting of which they are not an invitee) AND we have removal
      // URLs set.
      if (userIsInvitee && removeFromMeetingUrl && removeFromChatUrl) {
        removeAttendeeFromMeeting();
        window.removeEventListener("beforeunload", removeAttendeeFromMeeting);
      }
    };
  }, [
    userIsInvitee,
    isLeavingReception,
    removeFromMeetingUrl,
    removeFromChatUrl,
    removeAttendeeFromMeeting,
  ]);
};

export default useNotifyOnMeetingLeave;
